import { useMutation } from '@tanstack/react-query';
import { endpoints, ID } from '@rossum/api-client';
import { useApiClient } from '../../../../../lib/apiClient';
import { externalHookTemplateSchema } from '../customExtensionSchema';
import { toUpstreamMetadata } from '../upstreamSchema';

export const useInstall = () => {
  const apiClient = useApiClient();
  return useMutation({
    mutationFn: async ({
      version,
      externalHookTemplateId,
      hookInterfaceId,
    }: {
      version: string;
      externalHookTemplateId: string;
      hookInterfaceId: ID;
    }) =>
      apiClient
        .request(
          endpoints.hookInterfaces.invoke(hookInterfaceId, {
            payload: {
              name: 'checkout_hook_template',
              id: externalHookTemplateId,
              version,
            },
          })
        )
        .then(hookTemplate => externalHookTemplateSchema.parse(hookTemplate))
        .then(async hookTemplate => {
          const newHook = await apiClient.request(
            endpoints.hooks.create({
              type: hookTemplate.type,
              description: hookTemplate.description,
              name: hookTemplate.name,
              events: hookTemplate.events,
              config: {
                ...hookTemplate.config,
                code: hookTemplate.config.code ?? '',
              },
              queues: [],
              extensionSource: 'custom',
              metadata: {
                upstream: toUpstreamMetadata({
                  externalHookTemplateId,
                  hookInterfaceId,
                  version,
                }),
              },
            })
          );

          await Promise.all(
            hookTemplate.hook_interfaces.map(hookInterface =>
              apiClient.request(
                endpoints.hookInterfaces.create({
                  description: hookInterface.description,
                  hook: newHook.url,
                  metadata: hookInterface.metadata,
                  name: hookInterface.name,
                  payload: hookInterface.payload,
                  type: hookInterface.type,
                })
              )
            )
          );

          return newHook;
        }),
  });
};
